import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { ElementGroup } from "../../../models/enums/element-group";
import { ElementFormComponent } from "../element-form/element-form.component";
import { ElementPriorityFormComponent } from "../element-priority-form/element-priority-form.component";

@Component({
  selector: "ngx-element-list",
  templateUrl: "./element-list.component.html",
  styleUrls: ["./element-list.component.scss"],
})
export class ElementListComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  actions: EntityListAction[];
  filterInfo: NameValue[] = [];
  editingName: { name: string };
  constructor(private tabsservice: TabularService, private splashFormService: SplashFormService, private _VoucherKindInfo: VoucherKindInfo) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
    this.inputEditorform = ElementFormComponent;
    //
    if (_VoucherKindInfo.VoucherKindId <= ElementGroup.Other)
      this.filterInfo = [{ Name: "ElementGroupCode", Value: _VoucherKindInfo.VoucherKindId, Operator: "lte" }];
    else this.filterInfo = [{ Name: "ElementGroupCode", Value: _VoucherKindInfo.VoucherKindId, Operator: "eq" }];
  }
  ngOnInit() {
    this.apiName = "Element";
    this.areaName = "Payroll";
    this.label = "تعریف عوامل";
    this.setactions();
  }
  onActionClick(action: EntityListAction, onRowSelected: Element, onRowsSelected: Element[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "MakeDefaultElement") {
      this.splashFormService.openDialog("", "در حال ایجاد عوامل");
      this.httpCommonService
        .get(`Element/MakeDefaultElement/${this._VoucherKindInfo.VoucherKindId}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
            this.splashFormService.closeLoading();
            this.sts.showDialog("عوامل با موفقیت ایجاد شد.", "");
          },
          (error) => {
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در ایجاد عوامل");
            this.splashFormService.closeLoading();
          }
        );
    } else if (action.name === "UpdateComputationalPriority") {
      this.splashFormService.openDialog("", "در حال الویت بندی عوامل");
      this.httpCommonService
        .get("Element/UpdateComputationalPriority")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.sts.showDialog("الویت عوامل با موفقیت انجام شد.", "");
            this.splashFormService.closeLoading();
          },
          (error) => {
            this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در اولویت عوامل");
            this.splashFormService.closeLoading();
          }
        );
    } else {
      this.dialogService
        .open(
          ElementPriorityFormComponent,
          {
            currentrow: onRowSelected,
            apiName: this.apiName,
            areaName: this.areaName,
            label: action.displayName,
            PriorityName: action.name,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
            closeOnEscape: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model) => {
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
        });
    }
  }
  setactions() {
    this.actions = [
      {
        name: "MakeDefaultElement",
        disabled: false,
        displayName: "ایجاد عوامل عمومی",
        iconName: "icon-edit2",
        apiName: "Element/MakeDefaultElement",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.samePermission,
      },
      {
        name: "UpdateComputationalPriority",
        disabled: false,
        displayName: "الویت خودکار عوامل",
        iconName: "icon-sort-o",
        apiName: "Element/UpdateComputationalPriority",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.samePermission,
      },
      {
        name: "CalculationPriority",
        disabled: false,
        displayName: "الویت در محاسبه",
        iconName: "icon-sort-o",
        apiName: "Element",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.managePermission,
      },
      {
        name: "DataEntryPriority",
        disabled: false,
        displayName: "الویت در ورود اطلاعات",
        iconName: "icon-sort-o",
        apiName: "Element",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.managePermission,
      },
      {
        name: "ReportPriority",
        disabled: false,
        displayName: "الویت در گزارشات",
        iconName: "icon-sort-o",
        apiName: "Element",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.managePermission,
      },
      {
        name: "IssuePriority",
        disabled: false,
        displayName: "الویت در حکم",
        iconName: "icon-sort-o",
        apiName: "Element",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.managePermission,
      },
      {
        name: "ShowInBillPay",
        disabled: false,
        displayName: "نمایش در فیش",
        iconName: "icon-sort-o",
        apiName: "Element",
        areaName: "Payroll",
        requireSelectedrows: false,
        permission: Permission.managePermission,
      },
    ];
  }
}
